var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcons4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.2886H15.8033C15.07 17.2886 14.3733 17.5727 13.86 18.0861L12.2925 19.6352C11.5775 20.3411 10.4133 20.3411 9.69835 19.6352L8.13083 18.0861C7.6175 17.5727 6.91167 17.2886 6.1875 17.2886H5.5C3.97833 17.2886 2.75 16.0694 2.75 14.5661V4.56525C2.75 3.06191 3.97833 1.84277 5.5 1.84277H16.5C18.0217 1.84277 19.25 3.06191 19.25 4.56525V14.5661C19.25 16.0603 18.0217 17.2886 16.5 17.2886Z",
    stroke: "#15194B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.16715C12.1796 9.16715 13.1358 8.21089 13.1358 7.0313C13.1358 5.85171 12.1796 4.89551 11 4.89551C9.82041 4.89551 8.86415 5.85171 8.86415 7.0313C8.86415 8.21089 9.82041 9.16715 11 9.16715Z",
    stroke: "#15194B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 14.3555C14.6667 12.7055 13.0258 11.3672 11 11.3672C8.97417 11.3672 7.33334 12.7055 7.33334 14.3555",
    stroke: "#15194B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcons4);
export default __webpack_public_path__ + "static/media/menu-icons-4.5163280e34727ade8625c8c088114cc0.svg";
export { ForwardRef as ReactComponent };